// extracted by mini-css-extract-plugin
module.exports = {"element":"Option_element__i2hWD","selected":"Option_selected__qUUve"};